import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContentElement, GridCell } from '../../models/sections-model';


@Component({
  selector: 'kw-call-to-action-renderer',
  templateUrl: './call-to-action-renderer.component.html',
  styleUrls: ['./call-to-action-renderer.component.scss']
})
export class CallToActionRendererComponent {
  @Input() gridCell:GridCell
  @Input() edit:boolean;
  contentElements:ContentElement[];

  @Output() createGridCellContent = new EventEmitter<GridCell>();

  createContent(e){
    this.createGridCellContent.emit(e);
  }
}
